import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useToast } from '@/components/ui'
import { usersService } from '@/services/http/usersService'

import type { QueryParams } from '@/utils/queryParams'

type Params = {
  query: QueryParams
}

export const useRankingSimple = ({ query }: Params) => {
  const { toast } = useToast()

  const { data, isError, isLoading, refetch } = useQuery({
    queryKey: [
      'rankingSimple',
      {
        ...query,
      },
    ],
    queryFn: () => usersService.getRankingSimple({ query }),
  })

  useEffect(() => {
    if (isError)
      toast({
        title: 'Erro ao carregar dados do ranking',
        variant: 'destructive',
      })
  }, [isError, toast])

  if (data) {
    const { usersRanking, paginate, hasResetInPeriod } = data

    return {
      usersRanking,
      paginate,
      hasResetInPeriod,
      isLoading,
      refetchRankingSimple: refetch,
    }
  }

  return {
    usersRanking: [],
    paginate: {
      total: 0,
      page: 0,
      pages: 0,
      limit: 0,
    },
    hasResetInPeriod: false,
    isLoading,
    refetchRankingSimple: refetch,
  }
}
